import { FC } from 'react'
import style from './Loader.module.css'
import { Loader2 } from 'lucide-react'

type Size = 'small' | 'large'
interface Props {
  size?: Size
}
const Loader: FC<Props> = ({ size = 'large' }) => {
  return (
    <div role="status" className={`${style.loader} ${size == 'small' && style.loaderSmal}`}>
     <Loader2/>
    </div>
  )
}

export default Loader
